import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { IntermediadorPagamentoRequest } from '../../requests/financas/intermediador-pagamento.request';
import { IntermediadorPagamentoGetByIdResponse } from '../../responses/financas/intermediador-pagamento-get-by-id.response';
import { IntermediadorPagamentoLookupResponse } from '../../responses/financas/intermediador-pagamento-lookup.response';
import { IntermediadorPagamentoResponse } from '../../responses/financas/intermediador-pagamento-list.response';
import { ReturnStruct } from '../../structs/return.struct';

export class SaveIntermediadorPagamentoResponse extends ReturnStruct {
    idIntermediadorPagamento: number = 0;
}

@Injectable({
    providedIn: 'root',
})
export class IntermediadorPagamentoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas.trim() + 'IntermediadorPagamento';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(pagina: number = 1, tamanhoPagina: number = 20, descricao?: string, listIdAdquirente?: number[]): Observable<IntermediadorPagamentoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        (listIdAdquirente || []).forEach(id => {
            params = params.append('listIdAdquirente', id.toString());
        });

        return this.httpClient
            .get<IntermediadorPagamentoResponse>(this.apiUrl, { ...this.addHeaderToken(), params })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<IntermediadorPagamentoGetByIdResponse> {
        return this.httpClient
            .get<IntermediadorPagamentoGetByIdResponse>(`${this.apiUrl}/${id}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public post(request: IntermediadorPagamentoRequest): Observable<SaveIntermediadorPagamentoResponse> {
        return this.httpClient
            .post<SaveIntermediadorPagamentoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(id: number, request: IntermediadorPagamentoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(`${this.apiUrl}/${id}`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        return this.httpClient
            .delete<ReturnStruct>(`${this.apiUrl}/${id}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public bulkDelete(ids: number[]): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(`${this.apiUrl}/bulk-delete`, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookup(): Observable<IntermediadorPagamentoLookupResponse> {
        return this.httpClient
            .get<IntermediadorPagamentoLookupResponse>(`${this.apiUrl}/lookup`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
